import { render, staticRenderFns } from "./supplyCard.vue?vue&type=template&id=0c197a11&scoped=true"
import script from "./supplyCard.vue?vue&type=script&lang=js"
export * from "./supplyCard.vue?vue&type=script&lang=js"
import style0 from "./supplyCard.vue?vue&type=style&index=0&id=0c197a11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c197a11",
  null
  
)

export default component.exports